module.exports = __webpack_public_path__ + "img/follow-us-1.9f6bb0a5.jpg";